import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';

export default function AlertToggleButton({ open, toggle, showLabel, hideLabel }) {

  return (
    <ButtonWithIcon
      type="link"
      sprite={open ? 'ChevronUp' : 'ChevronDown'}
      iconRight
      onClick={toggle}
      className="alert-description--toggle-button e2e-toggle-alert-description">
      {open ? hideLabel : showLabel}
    </ButtonWithIcon>
  );
}

AlertToggleButton.propTypes = {
  open: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  showLabel: PropTypes.string.isRequired,
  hideLabel: PropTypes.string.isRequired,
};
